<template>
  <div>
    <div class="mask"></div>
    <div class="cookie-notice">
      <p>
        <!--The system determines that your current IP is in a non Chinese language
        region, and the site will redirect you to the corresponding region. Are
        you sure you want to jump?-->
        {{message}}
      </p>

      <div class="three-boxs">
        <div class="not-accept" @click="cancel">रद्द करें </div>
        <div class="accept" @click="confirm">पुष्टि करें </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
export default {
  props: ['message'],
  data() {
    return {
      mask2Show: false,
      strictly: require("@/assets/pcImg/plus.png"),
      strictlyShow: false,
      performance: require("@/assets/pcImg/plus.png"),
      performanceShow: false,
      functional: require("@/assets/pcImg/plus.png"),
      functionalShow: false,
      checked1: false,
      checked2: false,
      type: 0, //type为2直接显示弹出框。为1不显示
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
  created() {},
};
</script>
<style scoped>
/* 遮罩 */
.mask {
  background-color: rgba(0, 0, 0, 0.2);
  position: fixed;
  min-width: 100vw;
  min-height: 100vh;
  top: 0;
  z-index: 9999;
}
.mask2 {
  background-color: rgba(133, 133, 133, 0.9);
  position: fixed;
  min-width: 100vw;
  min-height: 100vh;
  top: 0;
  z-index: 999999;
}

.cookie-notice {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 520px;
  height: 200px;
  background-color: #fff;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #232323;
  font-weight: bold;
  overflow: auto;
}
.cookie-notice > img {
  width: 36.25px;
  height: 47.5px;
  margin-top: 51.25px;
}
.cookie-notice > .title {
  font-size: 25.625px;
  margin-top: 13.75px;
}
.cookie-notice > p {
  width: calc(100% - 60px);
  font-size: 10px;
  margin-top: 35px;
  line-height: 15px;
}
.cookie-notice > .three-boxs {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 60px;
  margin-bottom: 40px;
  width: calc(100% - 60px);
  font-size: 12.5px;
}
.three-boxs > div {
  cursor: pointer;
  color: #2e67ea;
  width: 122.5px;
  text-align: center;
}
.not-accept {
  border: 0.625px solid #2e67ea;
  height: 31.25px;
  line-height: 31.25px;
  border-radius: 31.25px;
  margin-right: 16px;
}
.three-boxs > .accept {
  border: 0.625px solid #2e67ea;
  background-color: #2e67ea;
  color: #fff;
  height: 31.25px;
  line-height: 31.25px;

  border-radius: 31.25px;
}

/* 第二页 */
.privacy {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 438.75px;
  height: calc(90vh - 40px);
  padding-bottom: 40px;
  background-color: #fff;
  z-index: 9999999;
  border: 0.625px solid #707070;
  overflow: auto;
}
.privacy-logo {
  height: 47.5px;
  border-bottom: 0.625px solid #e4e5e9;
}
.privacy-logo > img {
  width: 111.875px;
  height: 22.5px;
  margin-top: 15px;
  margin-left: 31.25px;
}
.privacy-main {
  width: calc(100% - 62.5px);
  padding-left: 31.25px;
  padding-right: 31.25px;
  font-size: 10px;
  padding-top: 12.5px;
}
.privacy-title {
  font-weight: bold;
  margin-top: 12, 5px;
  margin-bottom: 12.5px;
}
.privacy-main > p {
  line-height: 14px;
  margin-bottom: 12.5px;
}
.information {
  color: #2e67ea;
  margin-top: 12, 5px;
  margin-bottom: 12.5px;
}
.allow-all {
  width: 79.375px;
  height: 22.5px;
  background: #2e67ea;
  color: #fff;
  text-align: center;
  line-height: 22.5px;
  border-radius: 1.25px;
  margin-top: 12, 5px;
  margin-bottom: 12.5px;
  cursor: pointer;
}
.privacy-box {
  widows: 100%;
  border: 0.625px solid #cccccc;
}
.privacy-line {
  widows: 100%;
}
.privacy-line > .show {
  display: flex;
  justify-content: space-between;
  height: 31.25px;
  align-items: center;
  border-bottom: 0.625px solid #cccccc;
  font-weight: bold;
}
.privacy-line > .show > .left {
  display: flex;
}
.privacy-line > .show > .right {
  color: #2e67ea;
  margin-right: 10px;
  cursor: pointer;
}
.privacy-line > .show > .left > img {
  width: 10px;
  height: 10px;
  margin-left: 6px;
  margin-right: 8px;
  cursor: pointer;
}
.none {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.25s;
  background-color: #f2f2f2;
  line-height: 15px;
  padding: 0;
}
.none > p {
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.not-none {
  max-height: 100000px;
}

.choices {
  width: 103.75px;
  height: 22.5px;
  font-size: 8.75px;
  font-weight: bold;
  color: #ffffff;
  background-color: #2e67ea;
  float: right;
  margin-top: 25px;
  text-align: center;
  line-height: 22.5px;
  cursor: pointer;
}
.bottom-flex {
  width: 100%;
  color: #ffff;
  background-color: rgba(0, 0, 0, 0.7);
  border-color: #333;
  position: fixed;
  bottom: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
}
.bottom-flex > .left {
  line-height: 20px;
  padding: 5px 10px;
}
.bottom-flex > .right {
  display: flex;
}
.bottom-flex > .right > button {
  padding: 4px 8px;
  margin: 0;
  background-color: #fff;
  color: #000;
  font-size: 7.5px;
  margin-right: 10px;
  border-radius: 3px;
  cursor: pointer;
}
.bottom-flex > .right > .agree {
  background-color: #17aa56;
  color: #fff;
}
</style>
<style scoped>
/* 媒体查询 */
@media only screen and (max-width: 900px) {
  .cookie-notice {
    width: 88vw;
    height: 90vh;
  }
  .cookie-notice > .three-boxs {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }
  .three-boxs > div {
    cursor: pointer;
    color: #2e67ea;
    width: 100%;
    text-align: center;
    margin-top: 20px;
  }
  .three-boxs > div:first-child {
    text-align: left;
  }
}
@media only screen and (max-width: 800px) {
  .cookie-notice > .title {
    font-size: 20px;
  }
  .cookie-notice > p {
    font-size: 10px;
    font-weight: normal;
  }
  .three-boxs > div {
    font-size: 10px;
  }
  .three-boxs > div:first-child {
    font-weight: normal;
  }
}
@media only screen and (max-width: 750px) {
  .privacy {
    width: 90vw;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mycom/ipNotice.vue